<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
           
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">展业机构:</div>
                <el-input v-model="conditionData.zyjg" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">案件状态:</div>
                <el-select v-model="conditionData.dcTaskAction" size="small" placeholder="请选择" filterable>
                    <el-option
                    v-for="item in dcTaskActionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">财务状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in financeStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">是否已结算:</div>
                <el-select v-model="conditionData.IsEndCount" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in IsEndCount"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>

            
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="success" icon="el-icon-download" size="small" @click="getExcel">导出excel</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <!-- <el-table-column
                prop="accidentRiskID"
                label="案件ID"
                align="center"
                width="80"
                >
                </el-table-column> -->
                <el-table-column
                prop="anXinDcTaskId"
                label="案件ID"
                align="center"
                width="156"
                >
                </el-table-column>
                <el-table-column
                prop="cClmNo"
                label="报案号"
                align="center"
                width="150"
                >
                </el-table-column>
                <el-table-column
                prop="zyjg"
                label="展业机构"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="cPlyNo"
                label="保单号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="cProdName"
                label="产品名称"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="personDanger"
                label="出险人"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="cInsuredNme"
                label="被保人"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="appraisalFee"
                label="公估费"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="taskFee"
                label="机构作业费用"
                align="center"
                width="130"
                >
                </el-table-column>

                <el-table-column
                prop="cSvyMode"
                label="调查方式"
                align="center"
                width="120"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="cSvyAll"
                label="调查地区"
                align="center"
                width="150"
                >
                </el-table-column> -->
                <el-table-column
                prop="cSvyAddr"
                label="调查地址"
                align="center"
                width="200"
                >
                </el-table-column>

                <el-table-column
                prop="companyName"
                label="商保公司名称"
                align="center"
                width="160"
                >
                </el-table-column>

                <el-table-column
                prop="creationTime"
                label="创建时间"
                align="center"
                width="160"
                >
                </el-table-column>

                <el-table-column
                prop="operatorMechanism"
                label="作业机构"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="dcTaskAction"
                label="案件状态"
                align="center"
                width="160"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.dcTaskAction==-1">拒绝任务</span>
                        <span v-if="scope.row.dcTaskAction==0">新案件</span>
                        <span v-if="scope.row.dcTaskAction==10">案件待派机构</span>
                        <span v-if="scope.row.dcTaskAction==20">案件作业中</span>
                        <span v-if="scope.row.dcTaskAction==21">案件待展业机构审核</span>
                        <span v-if="scope.row.dcTaskAction==25">案件待总部审核</span>
                        <span v-if="scope.row.dcTaskAction==26">待回复委托主体</span>
                        <span v-if="scope.row.dcTaskAction==30">案件已回复委托主体</span>
                        <span v-if="scope.row.dcTaskAction==40">案件完成</span>
                        <span v-if="scope.row.dcTaskAction==50">案件结案</span>
                        <span v-if="scope.row.dcTaskAction==60">案件委托主体审核退回</span>
                        <span v-if="scope.row.dcTaskAction==70">取消委托</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="160"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.financeState==0">其他</span>
                        <span v-if="scope.row.financeState==10">已开票未回款</span>
                        <span v-if="scope.row.financeState==20">已开票部分回款</span>
                        <span v-if="scope.row.financeState==30">回款完成</span>
                        <span v-if="scope.row.financeState==40">回款未开票</span>
                    </template>
                </el-table-column>

                <el-table-column
                prop="isEndCount"
                label="是否已结算"
                align="center"
                width="160"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isEndCount==1">已结算</span>
                        <span v-if="scope.row.isEndCount==0">未结算</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                prop="isOld"
                label="是否新系统"
                align="center"
                width="160"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isOld==1">否</span>
                        <span v-if="scope.row.isOld==0">是</span>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                prop=""
                label="作业机构"
                align="center"
                width="160"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.province}}{{scope.row.city}}</span>
                </template>
                </el-table-column>

                <el-table-column
                prop=""
                label="省"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.province}}</span>
                </template>
                </el-table-column><el-table-column
                prop=""
                label="市"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.city}}</span>
                </template>
                </el-table-column> -->
                
                <el-table-column
                fixed="right"
                label="操作"
                width="280px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceDetail(scope.row)">查看关联立项</el-button>
                    <el-button type="text" icon="el-icon-date" size="mini" @click="dailyList(scope.row)">查看日志</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCaseTip(scope.row)" v-if="roleName=='总管理员'">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="案件详情" width="860px">
            <div class="dialog">
                <div class="item">
                    <div class="label">报案号:</div>
                    <el-input v-model="detailData.cClmNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">展业机构:</div>
                    <el-input v-model="detailData.zyjg" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                
                <div class="item">
                    <div class="label">保单号:</div>
                    <el-input v-model="detailData.cPlyNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">产品名称:</div>
                    <el-input v-model="detailData.cProdName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">出险人:</div>
                    <el-input v-model="detailData.personDanger" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">被保人:</div>
                    <el-input v-model="detailData.cInsuredNme" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">公估费:</div>
                    <el-input v-model="detailData.appraisalFee" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">机构作业费用:</div>
                    <el-input v-model="detailData.taskFee" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">调查方式:</div>
                    <el-input v-model="detailData.cSvyMode" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">调查地址:</div>
                    <el-input v-model="detailData.cSvyAddr" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">商保公司名称:</div>
                    <el-input v-model="detailData.companyName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">创建时间:</div>
                    <el-input v-model="detailData.creationTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">作业机构:</div>
                    <el-input v-model="detailData.operatorMechanism" size="small" placeholder="" style="width:250px"></el-input>
                </div>



               
                <div class="item">
                    <div class="label">财务状态:</div>
                    <el-select v-model="detailData.financeState" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in financeStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                
                <div class="item">
                    <div class="label">立项名:</div>
                    <el-input v-model="detailData.standName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                
                <div class="item">
                    <div class="label">是否结算:</div>
                    <el-select v-model="detailData.isEndCount" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in IsEndCount"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                
                <div class="item item-textarea">
                    <div class="label">未决备注:</div>
                    <el-input type="textarea" v-model="detailData.outStandingRemarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
                <div class="item item-textarea">
                    <div class="label">结算备注:</div>
                    <el-input type="textarea" v-model="detailData.endCountRemarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
                <div style="width:765px">
                    <el-table
                    :data="detailData.institutions"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                        <el-table-column
                        prop="name"
                        label="作业机构"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="fee"
                        label="作业费用"
                        align="center"
                        >
                        </el-table-column>
                </el-table>
                </div>

                
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDetail" title="查看关联立项" width="1600px">
            <el-table
                :data="invoiceList"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-if="scope.row.financeState==20">已开票部分回款</span>
                    <span v-if="scope.row.financeState==30">回款完成</span>
                    <span v-if="scope.row.financeState==40">已回款未开票</span>
                    <span v-if="scope.row.financeState==50">红冲</span>
                    <span v-if="scope.row.financeState==60">作废</span>
                    <span v-if="scope.row.financeState==0">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <!-- <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceItemDetail(scope.row)">查看详情</el-button>
                </template>
                </el-table-column> -->
            </el-table>
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentInvoiceChange"
                    background
                    layout="prev, pager, next ,sizes ,total"
                    :total="invoiceCount"
                    :current-page="conditionInvoiceData.pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="conditionInvoiceData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDailyDialog" title="查看日志" width="800px">
            <el-timeline>
                <el-timeline-item :timestamp="item.cDateTime" placement="top" v-for="(item,index) in daily" :key="index">
                <p> 
                    {{item.behavior==0?'插入':''}}
                    {{item.behavior==1?'更新':''}}
                    {{item.behavior==2?'单个关联':''}}
                    {{item.behavior==3?'批量关联':''}}
                    {{item.behavior==4?'取消关联':''}}
                </p>
                </el-timeline-item>
               
            </el-timeline>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD} from '../../../utils/index'
import { provinceAndCityData , CodeToText } from "element-china-area-data";

export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            time:'',
            district:'',
            provinceAndCityData:provinceAndCityData,
            title:'',
            isDetailDialog:false,
            totalCount:0,
            conditionData:{
                Multiple:"",
                StandName:"",
                financeState:null,
                IsEndCount:null,
                StartTime:null,
                EndTime:null,
                dcTaskAction:null,
                zyjg:'',
                pageIndex:1,
                pageSize:20,
            },
            tableData:[],
            detailData:{},
            lossStatusList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'已指派未查勘',
                    value:1,
                },{
                    label:'已查勘待审核',
                    value:2,
                },{
                    label:'查勘已审核',
                    value:3,
                },{
                    label:'查勘退回',
                    value:5,
                },{
                    label:'品管已审核待转录',
                    value:6,
                },{
                    label:'已转录待保险公司审核',
                    value:7,
                },
            ],
            caseStatusList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'案件未完成',
                    value:1,
                },{
                    label:'已核损待结案',
                    value:2,
                },{
                    label:'已结案',
                    value:3,
                }
            ],
            casePropertyList:[
                {
                    label:'本地案件',
                    value:1,
                },
                {
                    label:'异地案件',
                    value:0,
                }
            ],
            isGuangDong:[
                {
                    label:'是',
                    value:1,
                },
                {
                    label:'否',
                    value:0,
                }
            ],
            IsEndCount:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'未结算',
                    value:0,
                },{
                    label:'已结算',
                    value:1,
                },
            ],
            isYueList:[
                {
                    label:'否',
                    value:0,
                },{
                    label:'是',
                    value:1,
                },
            ],
            financeStateList:[
                {
                    label:'全部',
                    value:null,
                },{
                    label:'已开票未回款',
                    value:10,
                },{
                    label:'已开票部分回款',
                    value:20,
                },{
                    label:'回款完成',
                    value:30,
                },{
                    label:'回款未开票',
                    value:40,
                },{
                    label:'其他',
                    value:0,
                }
            ],

            isRelevanceDetail:false,

            conditionInvoiceData:{
                RelationID:null,
                IsJoinCase:null,
                Multiple:"",
                financeState:null,
                StartTime:"",
                EndTime:"",
                CompanyName:"",
                pageIndex:1,
                pageSize:10,
            },
            invoiceList:[],
            invoiceCount:0,
            row:null,

            isDailyDialog:false,
            daily:[
                
            ],
            dcTaskActionList:[
                {
                    label:'全部',
                    value:null,
                },{
                    label:'拒绝任务',
                    value:-1,
                },{
                    label:'新案件',
                    value:0,
                },{
                    label:'案件待派机构',
                    value:10,
                },{
                    label:'案件作业中',
                    value:20,
                },{
                    label:'案件待展业机构审核',
                    value:21,
                },{
                    label:'案件待总部审核',
                    value:25,
                },{
                    label:'待回复委托主体',
                    value:26,
                },{
                    label:'案件已回复委托主体',
                    value:30,
                },{
                    label:'案件完成',
                    value:40,
                },{
                    label:'案件完成',
                    value:40,
                },{
                    label:'案件结案',
                    value:50,
                },{
                    label:'案件委托主体审核退回',
                    value:60,
                },{
                    label:'取消委托',
                    value:70,
                }
            ],
            roleName:localStorage.getItem('roleName')


        }
    },
    created(){
       

    },
    mounted(){
        this.loadingData();
       
    },
    methods:{
        async dailyList(row){
            this.isDailyDialog = true;
            let res = await api.externalQueryCaseLogs({
                "caseID": JSON.stringify(row.accidentRiskID),
                "caseType": 4
            });
            this.daily = res.data.data;
        },
        handleCurrentInvoiceChange(pageIndex){
            this.conditionInvoiceData.pageIndex = pageIndex;
            this.relevanceDetail(this.row);
        },
        async relevanceDetail(row){
            console.log(row);
            this.row = row;
            this.isRelevanceDetail = true;
            this.conditionInvoiceData.RelationID = row.relatedID;
            let res  = await api.querySPAccidentRiskother(this.conditionInvoiceData);
            this.invoiceList = res.data.data.entitys;
            this.invoiceCount = res.data.data.pageLen;
            for(let i in this.invoiceList){
                this.invoiceList[i].billingTimeStr = parseTimeD(this.invoiceList[i].billingTime)
            }
        },
        relevanceItemDetail(row){
            localStorage.setItem('editData',JSON.stringify(row));
            const { href } = this.$router.resolve({
                name: "carInsuranceDetail",
                query:{
                    id:row.standProjectId,
                    isDetail:true,
                }
            });
            window.open(href, '_blank');
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.queryAccidentRisk(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].creatTime = parseTimeS(this.tableData[i].creatTime)
            }
        },
        deleteCaseTip(row){
            this.$confirm('是否删除案件编号：'+row.cClmNo+'?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCase(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async deleteCase(row){
            let res = await api.deleteAccidentRisk({
                ID:row.anXinDcTaskId
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.loadingData();
            }

        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        reset(){
            this.time = null;
            this.district = '',
            this.conditionData = {
                Multiple:"",
                StandName:"",
                financeState:null,
                IsEndCount:null,
                StartTime:null,
                EndTime:null,
                dcTaskAction:null,
                zyjg:'',
                pageIndex:1,
                pageSize:20,
            },
            this.loadingData();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        
        detail(row){
            this.detailData = row;
            this.isDetailDialog = true;
        },
        async getExcel(){
            let option = {
                Multiple:this.conditionData.Multiple,
                StartTime:this.conditionData.StartTime,
                EndTime:this.conditionData.EndTime,
                IsEndCount:this.conditionData.IsEndCount,
                financeState:this.conditionData.financeState,
            }
            let res = await api.accidentRiskExport(option);
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            width: 360px;
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
            }
        }
        .item-textarea{
            width: 760px;
        }
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
